export const routes = {
  home: {
    path: "/",
    navigate: (params?: string) => (params ? `/?${params}` : "/"),
  },
  days: {
    path: "/days",
    navigate: (params?: string) => (params ? `/days?${params}` : "/days"),
  },
  rooms: {
    path: "/rooms",
    navigate: (params?: string) => (params ? `/rooms?${params}` : "/rooms"),
  },
  lectures: {
    path: "/lectures",
    navigate: (params?: string) =>
      params ? `/lectures?${params}` : "/lectures",
  },
  sessions: {
    path: "/sessions",
    navigate: (params?: string) =>
      params ? `/sessions?${params}` : "/sessions",
  },
  companies: {
    path: "/companies",
    navigate: (params?: string) =>
      params ? `/companies?${params}` : "/companies",
  },
  participants: {
    path: "/participants",
    navigate: (params?: string) =>
      params ? `/participants?${params}` : "/participants",
  },
  participantPasses: {
    path: "/participant-passes",
    navigate: (params?: string) =>
      params ? `/participant-passes?${params}` : "/participant-passes",
  },
  attendants: {
    path: "/attendants",
    navigate: (params?: string) =>
      params ? `/attendants?${params}` : "/attendants",
  },
  contests: {
    path: "/contests",
    navigate: (params?: string) =>
      params ? `/contests?${params}` : "/contests",
  },
};
